import { useForm } from 'react-hook-form';

import { zodResolver } from '@hookform/resolvers/zod';

import { AddUserForm, addUserSchema } from '@t/user/components/add-user/field-values.schema';

export const useAddUserCreateForm = () => {
  const methods = useForm<AddUserForm>({
    mode: 'onChange',
    resolver: zodResolver(addUserSchema),
    reValidateMode: 'onChange',
  });

  return methods;
};
